import React, { useState, useEffect } from "react";

const Services = () => {
  const [data, setData] = useState({
    bgColor: "",
    textColor: "",
    cardBgColor: "",
    cardTextColor: "",
    iconColor: "",
    title: "",
    description: "",
    services: [],
  });

  const [selectedTab, setSelectedTab] = useState(0);
  const apiUrl = import.meta.env.VITE_API_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/home/services`);
        const data = await response.json();
        console.log(data); 
        setData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  

  return (
    <div className="relative pt-8">
      <div
        className="py-8 sm:py-12 lg:py-16"
        style={{ backgroundColor: data.bgColor, color: data.textColor }}
      >
        <div className="mx-auto max-w-screen-xl px-6 md:px-12">
          {/* Section Title and Description */}
          <div className="mb-12 md:mb-16 text-center">
            <h2 className="mb-6 text-4xl font-bold md:text-5xl lg:text-5xl">
              {data.title}
            </h2>
            <p className="mx-auto text-sm md:text-md">{data.description}</p>
          </div>

          {/* Service Buttons (Grid Layout) */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 text-left gap-5 items-start justify-start lg:justify-center">
            {data.services.map((service, index) => (
              <button
                key={index}
                onClick={() => setSelectedTab(index)}
                className={`px-2 py-1 lg:px-4 lg:py-2 text-sm md:text-md font-semibold rounded-md transition-colors duration-300 ${
                  selectedTab === index ? "bg-transparent text-white" : "text-gray-700"
                }`}
                style={{
                  backgroundColor: selectedTab === index ? data.textColor : "transparent",
                  color: selectedTab === index ? data.bgColor : data.textColor,
                  borderColor: selectedTab === index ? data.bgColor : data.textColor,
                  textAlign: "left", // Ensure text starts from left
                }}
              >
                {service.title}
              </button>
            ))}
          </div>

          {/* Service Details */}
          <div
            className="p-6 bg-white rounded-lg shadow-lg text-justify mt-6"
            style={{
              backgroundColor: data.cardBgColor,
              color: data.cardTextColor,
            }}
          >
            <p className="text-sm text-justify lg:text-lg">
              {data.services[selectedTab] &&
                data.services[selectedTab].description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
